import { ColDef } from '@ag-grid-community/core';

import { InvestigatorForecastGridRow } from '../types/investigator-forecast-grid-row';

/**
 * Column definitions for patient group configuration.
 * We use aggFunc: 'first' to ensure correct grouping in the export.
 * Since we only show aggregated rows in the UI (as configured in the Excel export),
 * this aggregation function ensures the correct group names are displayed.
 */
export const INVESTIGATOR_FORECAST_PATIENT_GROUP_COLUMN_DEFS: ColDef<InvestigatorForecastGridRow>[] =
  [
    {
      aggFunc: 'first', // Using 'first' to correctly display group names in the export
      field: 'costType',
      hide: true,
      rowGroup: true,
    },
    {
      // Using agg func to correctly display sub group names in the export
      aggFunc: (params) => {
        const vals = params.values.filter((val) => !!val);

        return vals[0];
      },
      field: 'patientGroup',
      hide: true,
      rowGroup: true,
    },
  ];
